export default __webpack_public_path__ + "14.png";